<template>
  <el-row class="leapin-header" :style="{ background: type == 'white' ? 'transparent' : '#fff' }">
    <el-col :span="3" class="leapin-text-center">
      <img class="logo" :src="logo" />
    </el-col>
    <el-col :span="16" class="link-area">
      <div
        v-for="(item,index) in routeList"
        :key="index"
        :class="{
          'route-link': true,
          'active': $route.path === item.path
        }"
        :style="{ color: type == 'white' ? '#fff' : '#424355' }"
        @click="routeLinkTo(item)">
        {{ item.name }}
        <img v-if="$route.path === item.path" :src="circle" />
      </div>
    </el-col>
    <el-col :span="5" class="leapin-text-right">
      <div v-if="$store.state.user.userInfo && $store.state.user.userInfo.extra_info" class="admin-info">
        <img v-if="$store.state.user.userInfo.extra_info && $store.state.user.userInfo.extra_info.avatar" class="user-logo" :src="$store.state.user.userInfo.extra_info.avatar" />
        <div v-else class="no-img">{{ $store.state.user.userInfo.first_name[0] }}</div>
        <el-dropdown @command="handleCommand">
          <span class="el-dropdown-link">
            <span class="name" :style="{ color: type == 'white' ? '#fff' : '#424355' }">
              {{ $store.state.user.userInfo.first_name }} {{ $store.state.user.userInfo.last_name }}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
              
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="1" icon="el-icon-user" v-if="$store.state.user.userInfo.roles[0].key != 'coach'">
              <span>Profile</span>
            </el-dropdown-item>
            <el-dropdown-item command="2" icon="el-icon-s-promotion">
              <span>Log out</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        
      </div>
      
    </el-col>
  </el-row>
</template>

<script>
import { GetStorage } from "@/utils/utils";
export default {
  props: {
    type: {
      type: String,
      default: ''
    }
  },
  name: 'Header',
  data () {
    return {
      loginFlag: false,
      circle: require('@/assets/svgs/circle.svg'),
      logo: require('@/assets/svgs/logo.svg'),
      admin: require('@/assets/images/users/candidate2.png'),
      routeList: [
        { name: 'For Talent', path: '/Login?type=1' },
        { name: 'For Professionals', path: '/Login?type=2' }
      ],
    }
  },
  mounted() {
    //console.log(JSON.stringify(this.$store.state.user.userInfo))
    if (this.$store.state.user.userInfo && this.$store.state.user.userInfo.extra_info) {
      this.routeList = JSON.parse(GetStorage('permissionRoutes'))
    } else {
      this.routeList = [
        { name: 'For Talent', path: '/Login?type=1' },
        { name: 'For Professionals', path: '/Login?type=2' }
      ]
    }
  },
  methods: {
    handleCommand(command) {
      if (command === '1') {
        //进入个人中心
        this.$router.push('/CandidateShow')
      } else if (command === '2') {
        //退出登录
        this.$confirm('Are you sure to log out?', '', {
          confirmButtonText: 'Sure',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {
          this.$store.dispatch("user:fedLogOut").then(() => {
              window.location.href = "/";
          });
        }).catch(() => {});
      }
    },
    //路由跳转
    routeLinkTo(item) {
      this.$router.push(item.path)
    },
    //登陆注册
    routeLinkLogin(path) {
      this.$router.push(path)
    },

  },
}
</script>

<style scoped lang="scss">
.leapin-header {
  width: 100%;
  max-width: 1920px;
  display: flex;
  height: 80px;
  justify-content: flex-start;
  align-items: center;
  background: transparent;
  position: fixed;
  top: 0;
  z-index: 999;
  .admin-img {
    margin: 0 16px 0 0 !important;
  }
  .user-logo {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    margin: 0 32px;
  }
  .logo {
    width: 120px;
    height: 22px;
    margin: 0 32px;
  }
  .admin-info {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    .no-img {
      display: flex;
      justify-content: center;
      align-items: center;
      background: #6E62E5;
      color: #fff;
      font-size: 50px;
      border-radius: 50%;
      font-size: 15px;
      width: 40px;
      height: 40px;
      margin: 0 32px;
    }
  }

  .name {
    cursor: pointer;
    color: #4E5969;
    font-size: 14px;
    font-weight: 400;
    margin-right: 32px;
  }
  .link-area {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    .active { color: #6E62E5 !important;}
    .route-link {
      margin: 0 16px;
      cursor: pointer;
      color: #424355;
      font-family: "PingFang SC";
      font-family: Lato;
      font-size: 16px;
      font-style: normal;
      font-weight: 600;
      line-height: 24px; /* 150% */
      position: relative;
      z-index: 2;
      // min-width: 50px;
      // text-align: center;
      img {
        top: 3px;
        left: 3px;
        position: absolute;
        z-index: -1;
        width: 32px;
        height: 26px;
      }
    }
    .route-link:first-child {
      margin-left: 0;
    }
  }
}
</style>
